var _circle, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStageStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9999,
    cy: 12.0002,
    r: 12,
    fill: "#009B77",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_605_10930",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_605_10930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3958 18.0625C11.2153 17.8819 11.1215 17.6805 11.1146 17.4583C11.1076 17.2361 11.1944 17.0347 11.375 16.8541L15.3541 12.875H6.20831C5.9722 12.875 5.76734 12.7882 5.59373 12.6145C5.42012 12.4409 5.33331 12.2361 5.33331 12C5.33331 11.7638 5.42012 11.559 5.59373 11.3854C5.76734 11.2118 5.9722 11.125 6.20831 11.125H15.3541L11.375 7.16663C11.1944 6.98607 11.1076 6.78121 11.1146 6.55204C11.1215 6.32288 11.2153 6.11801 11.3958 5.93746C11.5764 5.7569 11.7778 5.66663 12 5.66663C12.2222 5.66663 12.4236 5.7569 12.6041 5.93746L18.0416 11.375C18.1389 11.4583 18.2083 11.5555 18.25 11.6666C18.2916 11.7777 18.3125 11.8888 18.3125 12C18.3125 12.1111 18.2916 12.2187 18.25 12.3229C18.2083 12.427 18.1389 12.5277 18.0416 12.625L12.6041 18.0625C12.4236 18.243 12.2222 18.3333 12 18.3333C11.7778 18.3333 11.5764 18.243 11.3958 18.0625Z",
    fill: "#009B77"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageStart);
export default __webpack_public_path__ + "static/media/StageStart.b8f92b15f0d368abab079b6432d34a7e.svg";
export { ForwardRef as ReactComponent };